import React from 'react';

const Logout = () => (
  <div />
);

export default Logout;
